import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76365bec")

_pushScopeId("data-v-76365bec")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title-modal" }, " Konfirmasi pesanan ", -1)
const _hoisted_2 = {
  class: "flex justify-end",
  fontSize: 14
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_ModalFailedAcceptOrder = _resolveComponent("ModalFailedAcceptOrder")!
  const _component_ModalSuccessAcceptOrder = _resolveComponent("ModalSuccessAcceptOrder")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_ModalV2, {
            key: 0,
            width: "w-9/12",
            isCustomTitle: true,
            id: `${_ctx.$attrs.id}`,
            scrollable: true,
            isSpaceTop: false,
            isNoPaddingBottom: true,
            onClose: _ctx.closeModal
          }, {
            "custom-title": _withId(() => [
              _hoisted_1
            ]),
            content: _withId(() => [
              _createVNode(_component_TableV2, {
                isSpaceTop: false,
                columns: _ctx.columns,
                borderTop: false,
                data: _ctx.dataKulioner,
                borderBottom: false,
                hidePagination: true,
                isNoPaddingBottom: true,
                borderRowColor: "#EBEBEB"
              }, null, 8, ["columns", "data"])
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_LpButton, {
                  title: "Terima",
                  textColor: "white",
                  onClick: _ctx.onUpdate,
                  loading: _ctx.isLoadingBtn
                }, null, 8, ["onClick", "loading"])
              ])
            ]),
            _: 1
          }, 8, ["id", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalFailedAcceptOrder, {
      modelValue: _ctx.openModalFailedAcceptOrder,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModalFailedAcceptOrder = $event)),
      onRetry: _ctx.onUpdate,
      onClose: _cache[2] || (_cache[2] = () => _ctx.$emit('refetch'))
    }, null, 8, ["modelValue", "onRetry"]),
    _createVNode(_component_ModalSuccessAcceptOrder, {
      modelValue: _ctx.openModalSuccessAcceptOrder,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalSuccessAcceptOrder = $event)),
      onClose: _cache[4] || (_cache[4] = () => _ctx.$emit('refetch')),
      onPrint: _ctx.onPrintOrder
    }, null, 8, ["modelValue", "onPrint"])
  ], 64))
})